<template>
  <div class="tab__content">
    <div class="tournament__filter  container fluid grid-list-lg px-0">
      <div class="layout row wrap align-center">
        <div
          class="flex xs12 sm8 md9 order-xs2 order-sm1 tournament__filter_categories"
        >
          <!-- <app-btn round color="dark-blue-grad">Результаты</app-btn>
          <app-btn round color="dark-blue-grad">Записи</app-btn> -->
        </div>
        <div
          class="flex xs12 sm4 md3 order-xs1 order-sm2 tournament__filter_search"
        >
          <div class="text-field text-field_round text-field_dark-blue">
            <div class="text-field__slot">
              <input v-model="query" type="text" placeholder="Поиск" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tournament__games container fluid grid-list-lg px-0">
      <div
        ref="gamesList"
        class="tournament__games_list layout row wrap"
        v-if="matches.length"
      >
        <div v-for="match in matches" :key="match.id" class="flex xs12">
          <component
            :is="match && match.status < 9 ? 'router-link' : 'a'"
            v-bind="getLinkAttrs(match)"
            class="tournament__game layout row ma-0 align-center"
            :class="{ empty: !match || match.status == 9 }"
          >
            <div
              class="flex px-0 tournament__game_type no-wrap"
              :style="{ width: typesMaxWidth }"
            >
              <span class="font-weight-bold">{{
                getRoundDescription(match.stage)
              }}</span>
            </div>
            <div class="flex tournament__teams">
              <div class="tournament__member">
                <div class="tournament__member__info text-xs-right">
                  <div class="tournament__member_name ellipsis">
                    {{
                      (match.player1 && match.player1.nickname) || "Пустой слот"
                    }}
                  </div>
                  <div class="tournament__member_country ellipsis">
                    {{
                      (match.player1 && match.player1.country)
                        | country("&nbsp;")
                    }}
                  </div>
                </div>
                <div
                  class="tournament__member__ava tournament__member__ava_red"
                >
                  <img
                    v-if="match.player1 && match.player1.avatar"
                    :src="match.player1.avatar"
                    alt="avatar"
                  />
                  <SvgIcon v-else size="80%" name="user-light" />
                </div>
              </div>
              <div class="tournament__teams__result">
                <div
                  class="tournament__teams__result_wrap"
                  v-if="checkMatchScore(match)"
                >
                  <span class="result-red">{{ match.player1.score }}</span>
                  <span class="result-delimeter">-</span>
                  <span class="result-blue">{{ match.player2.score }}</span>
                </div>
                <div class="tournament__teams__result_wrap" v-else>
                  <span class="result-empty"
                    ><SvgIcon size="18" name="close"
                  /></span>
                </div>
              </div>
              <div class="tournament__member">
                <div
                  class="tournament__member__ava tournament__member__ava_blue"
                >
                  <img
                    v-if="match.player2 && match.player2.avatar"
                    :src="match.player2.avatar"
                    alt="avatar"
                  />
                  <SvgIcon v-else size="80%" name="user-light" />
                </div>
                <div class="tournament__member__info">
                  <div class="tournament__member_name ellipsis">
                    {{
                      (match.player2 && match.player2.nickname) || "Пустой слот"
                    }}
                  </div>
                  <div class="tournament__member_country ellipsis">
                    {{
                      (match.player2 && match.player2.country)
                        | country("&nbsp;")
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex px-0 tournament__game_status no-wrap"
              :style="{ width: statsMaxWidth }"
            >
              <app-status v-if="checkMatchGroup(match.status, 'live')"
                >LIVE</app-status
              >
              <span v-else-if="checkMatchGroup(match.status, 'ended')"
                >Матч окончен</span
              >
              <span v-else-if="[1, 2].includes(match.status)">{{
                getMatchStatusDescr(match.status, "type")
              }}</span>
            </div>
          </component>
        </div>
      </div>
      <div
        class="tournament__games_list tournament__games_list-empty layout row wrap"
        v-else-if="!loading && !matches.length"
      >
        <div class="flex xs12">
          <div class="tournament__game py-4 text-xs-center">
            Список матчей пуст
          </div>
        </div>
      </div>
    </div>
    <app-paginator
      v-if="pagination && pagination.pageCount > 1"
      v-model="pagination.currentPage"
      :page-count="pagination.pageCount"
      :click-handler="fetchPageData"
      class="layout row align-center justify-center"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";
import { convertToUnit } from "@/core/util/helpers";
import tournamentsService from "@/services/tournaments";
import matchService from "@/services/match";

import AppPaginator from "@/components/ui/pagination/AppPaginator";
import AppStatus from "@/components/ui/status/AppStatus";

export default {
  components: { AppPaginator, AppStatus },

  data: () => ({
    typesMaxWidth: null,
    statsMaxWidth: null,

    loading: false,
    query: "",
    matches: [],
    pagination: {}
  }),

  computed: {
    ...mapGetters(["routeParams"]),

    roundDescriptions() {
      return {
        grandfinal: "Гранд финал",
        "1": "Финал",
        "2": "Полуфинал",
        "4": "Четвертьфинал"
      };
    }
  },

  watch: {
    matches: "calcWidth",
    routeParams: "fetchPageData",
    query: debounce(function() {
      this.fetchPageData(1);
    }, 300)
  },

  sockets: {
    notification(message) {
      const isAllowed = ["matches_performed", "tournament_changed"].includes(
        message.type
      );
      const onCurTournament =
        this.routeParams.tournament_id === message.tournament_id;

      if (isAllowed && onCurTournament) {
        this.fetchPageData(this.pagination.currentPage);
      }
    }
  },

  methods: {
    getLinkAttrs(match) {
      if (!match || match.status >= 9) return {};
      return {
        tag: "div",
        to: {
          name: "tournament-match",
          params: {
            tournament_id: this.routeParams.tournament_id,
            match_id: match.id
          }
        }
      };
    },

    async fetchPageData(page) {
      if (this.loading) return;
      this.loading = true;
      let params = {
        "per-page": 8
      };

      if (page) {
        params.page = page;
      }

      if (this.query && this.query.length) {
        params.query = this.query;
      }

      // console.log(
      //   "tournamentsService.getMatches",
      //   this.routeParams.tournament_id,
      //   params
      // );

      let { matches, ...pagination } = await tournamentsService.getMatches(
        this.routeParams.tournament_id,
        { params }
      );
      this.matches = matches;
      this.pagination = pagination;

      this.loading = false;
      this.$store.dispatch("tournaments/updateTournament");
    },

    getMatchStatusDescr(status, name) {
      return matchService.getStatusDescription(status)[name] || null;
    },

    getRoundDescription(stage) {
      return this.roundDescriptions[stage] || "Стадия 1/" + stage;
    },

    checkMatchGroup(status, name) {
      return matchService.getStatusGroup(status).includes(name);
    },

    calcMaxWidth(selector) {
      let list = [].slice.call(this.$el.querySelectorAll(selector));
      return convertToUnit(
        Math.max.apply(
          Math,
          list.map(n => n.clientWidth)
        )
      );
    },

    calcWidth() {
      this.typesMaxWidth = this.calcMaxWidth(".tournament__game_type span");
      this.statsMaxWidth = this.calcMaxWidth(".tournament__game_status span");
    },

    checkMatchScore(match) {
      if (match && match.player1 && match.player2) {
        return match.player1.score + match.player2.score == 0;
      }
      return false;
    }
  },

  created() {
    this.fetchPageData();
  }
};
</script>

<style lang="scss">
.match {
  &__info {
    display: flex;
    flex-direction: column;
    // width: 100%;
    flex: 1 1 40% !important;
  }

  &__type {
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    margin: 8px 0;

    &_live {
      span {
        color: #e72f31;
      }

      .status {
        vertical-align: bottom;

        span {
          margin-left: 8px;
        }
      }
    }
  }

  &__status {
    font-size: 12px;
    line-height: 16px;

    &_date {
      color: #757987;

      span {
        font-weight: bold;
        color: #fff;
      }
    }

    &_live {
      color: #fff;
      background: #e72f31;
      box-shadow: 0px 0px 10px #ff0000;
      border-radius: 2px;
      padding: 4px 15px 5px 15px;
      display: inline-block;
    }
  }

  &__type,
  &__status {
    flex: 0 1 auto;
  }

  &__result {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 30% !important;

    &_count {
      font-weight: bold;
      font-size: 52px;
      line-height: 71px;
      color: #fff;

      &.counter-empty {
        color: rgba(#fff, 0.2);
      }
    }

    &_disput {
      .btn {
        border-radius: 3px;
        font-weight: bold;
        font-size: 24px;
        line-height: 33px;
        padding: 12px 64px;
      }
    }
  }

  &__winner {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1 1 40% !important;
    max-width: 40%;

    &_empty {
      background: #161e36;
      border-radius: 6px;
      padding: 13px 40px;

      font-weight: bold;
      font-size: 18px;
      line-height: 25px;
      max-width: 100%;
    }

    &_red,
    &_blue {
      font-weight: normal;
      padding: 13px 28px;
      border-radius: 6px;
      max-width: 90%;

      span {
        display: inline-block;
        vertical-align: bottom;
        max-width: 80%;
      }
    }

    &_red {
      background: #e72f31;
    }

    &_blue {
      background: #1480b2;
    }
  }
}

.chat,
.team_red,
.team_blue {
  display: flex;
  flex: 1 1 auto;
}

.team_red,
.team_blue {
  max-width: 110px;
  min-width: 110px;

  &.tournament__member {
    background: none;
    padding: 0;
    border-radius: 0;
    flex-direction: column;
    align-items: flex-start;
  }

  .tournament__member {
    &_name,
    &_country,
    &__ava {
      width: 100%;
      min-width: 0;
      max-width: 110px;
    }

    &__ava {
      margin: 0 !important;
      margin-top: 8px !important;
      height: 110px;
      transition: 0.3s;

      display: flex;
      align-items: center;
      justify-content: center;

      img,
      svg {
        display: block;
        width: 100%;
      }

      svg {
        margin: 0;
        width: 80%;
      }

      .btn__content {
        justify-content: center;
      }

      &:active {
        opacity: 0.6;
      }
    }
  }
}

.team_red {
  margin-right: 15px;
  text-align: left;

  .tournament__member__ava {
    &:hover {
      border-color: #ffd0d1;
      box-shadow: 0px 0px 20px #ff4749;
    }
  }
}
.team_blue {
  margin-left: 15px;
  text-align: right;

  .tournament__member__ava {
    &:hover {
      border-color: #b3e7ff;
      box-shadow: 0px 0px 20px #1480b2;
    }
  }
}
.chat {
  margin: 0 15px;
  flex-direction: column;

  .title {
    font-weight: 900;
    font-size: 28px;
    line-height: 34px;
    color: #fff;
    text-align: center;
  }

  &__header {
    position: relative;

    .invite_admin {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  &__wrap {
    background: rgba(#fff, 0.05);
    border-radius: 4px;
    padding: 30px;
    width: 100%;
  }

  &__messages {
    width: 100%;
  }

  &__form {
    margin-top: 30px;

    .divider {
      margin: 30px 0;
      opacity: 0.18;
    }

    &_actions {
      display: flex;
      flex-direction: row;
      margin-top: 30px;

      .btn {
        width: 200px;
      }
    }

    @include breakpoint("xs-only") {
      &_actions {
        margin: 0 -16px;
        padding: 8px;
        flex-direction: column;

        .btn {
          width: auto;
          margin: 8px;
        }
      }
    }

    .text-field {
      padding: 16px 20px;
    }
  }

  &__text {
    font-size: 14px;
    line-height: 19px;
    margin: 0 auto;
    margin-bottom: 30px;
    max-width: 580px;
    color: #7f8492;

    &_warning {
      background: rgba(231, 47, 49, 0.1);
      padding: 48px 30px;
      border: 2px solid #e72f31;
      box-sizing: border-box;
      border-radius: 4px;

      color: #e72f31;
      text-shadow: 0px 0px 15px rgba(255, 0, 0, 0.5);
      font-size: 15px;
      line-height: 18px;
      text-align: center;

      .title {
        color: #e72f31;
        font-weight: bold;
        font-size: 36px;
        line-height: 42px;
        text-transform: uppercase;
      }
    }
  }
}

.message {
  border-radius: 2px;
  padding: 16px 0;
  display: flex;
  flex: 1 1 auto;
  max-width: 380px;

  &__content {
    margin-left: 10px;
    margin-right: 0;

    .message_me & {
      margin-right: 10px;
      margin-left: 0;
    }
  }

  &:not(.message_me) {
    align-self: flex-start;
  }

  &_me {
    align-self: flex-end;
  }

  &__text {
    position: relative;
    margin-left: 16px;

    .message_me & {
      margin-left: 0;
      margin-right: 16px;
    }

    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 16px;
      height: 16px;
      left: -16px;
      top: 0;
      border-right: 8px solid rgba(#fff, 0.15);
      border-top: 8px solid rgba(#fff, 0.15);
      border-left: 8px solid transparent;
      border-bottom: 8px solid transparent;

      .message_me & {
        left: auto;
        right: -16px;
        border-left: 8px solid rgba(#7c9fff, 0.15);
        border-top: 8px solid rgba(#7c9fff, 0.15);
        border-right: 8px solid transparent;
        border-bottom: 8px solid transparent;
      }
    }

    &_wrap {
      padding: 10px 20px 15px 20px;
      background: rgba(#fff, 0.15);
      border-radius: 6px;
      border-top-left-radius: 0;

      .message_me & {
        background: rgba(#7c9fff, 0.15);
        border-radius: 6px;
        border-top-right-radius: 0;
      }
    }
  }

  &__user {
    &_ava {
      width: 100%;
      max-width: 40px;
      height: 40px;
      background: #7f8492;

      flex: 1 0 auto;

      .message_me & {
        background: #8e8b80;
      }
    }

    &_name {
      font-weight: 800;
      font-size: 14px;
      line-height: 15px;
      margin-bottom: 8px;

      .message_me & {
        text-align: right;
      }
    }
  }
}

@include breakpoint("xs-only") {
  .match-header {
    flex-wrap: wrap;

    .match__info {
      flex: 1 1 50% !important;
      max-width: 50% !important;
      order: 1;
      margin-bottom: 20px;
    }
    .match__winner {
      order: 2;
    }
    .match__result {
      order: 3;
    }
    .match__winner,
    .match__result {
      flex: 1 1 100% !important;
      max-width: 100% !important;
      justify-content: center;
    }

    .match__winner_red,
    .match__winner_blue {
      max-width: 100%;
      display: flex;

      span {
        max-width: 100%;
      }
    }
  }

  .team-columns {
    flex-wrap: wrap;

    .tournament__member {
      flex: 1 0 50% !important;
      max-width: 50%;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      order: 1;

      &.team_blue {
        align-items: flex-end;
      }
    }

    .chat {
      order: 2;
      margin: 0;
      margin-top: 30px;
      width: 100%;

      .title {
        text-align: left;
      }
    }

    .chat__wrap {
      padding: 16px;
    }

    .message {
      flex-direction: column;

      &__user_ava {
        display: none;
      }

      &__content {
        margin: 0;
      }

      // &__text {
      //   &:after {
      //   }
      // }
    }
  }
}
</style>
